export default "__VITE_ASSET__GqZiKzsO__"